"use client";

import posthog from "posthog-js";
import { Component, ErrorInfo, ReactNode } from "react";
import Button from "./Button";
import Typography from "./Typography";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class GlobalErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);

    // Ensure posthog is initialized before capturing
    if (posthog) {
      posthog.capture("client_side_exception", {
        $exception_type: error.name,
        $exception_message: error.message,
        $exception_stack: error.stack,
        componentStack: errorInfo.componentStack,
        location: window.location.href,
        // Additional properties for easier filtering
        error_name: error.name,
        error_message: error.message
      });
      console.log("posthog.capture", posthog.capture);
    }
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col">
          <main className="max-w-5xl mx-auto py-8 px-3 flex flex-col items-center justify-center flex-1 text-slate-950 text-center">
            <Typography variant="h3">Something went wrong</Typography>
            <Typography variant="body1" className="mt-4 text-slate-500 max-w-xl">
              We apologize for the inconvenience. The error has been logged automatically and our team will look into it.
            </Typography>
            
            <Button
              onClick={() => window.location.reload()}
              className="mt-8"
            >
              Reload Page
            </Button>
          </main>
        </div>
      );
    }

    return this.props.children;
  }
}
